import { FC, useEffect } from 'react';
import { createPortal } from 'react-dom';
import { useTranslation } from 'react-i18next';
import styles from './AppStatusIncidents.module.scss';

type ImageViewerModalProps = {
  alt: string;
  isOpen: boolean;
  onClose: () => void;
  url: string;
};

const ImageViewerModal: FC<ImageViewerModalProps> = ({ alt, isOpen, onClose, url }) => {
  const { t } = useTranslation();
  useEffect(() => {
    if (!isOpen) return undefined;

    const closeOnEscape = (event: KeyboardEvent) => {
      if (event.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', closeOnEscape);
    return () => document.removeEventListener('keydown', closeOnEscape);
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return createPortal(
    <div
      className={styles['image-viewer-overlay']}
      role="dialog"
      aria-modal="true"
      aria-label={alt}
      onMouseDown={(event) => {
        if (event.target === event.currentTarget) onClose();
      }}
    >
      <button
        type="button"
        className={styles['image-viewer-close']}
        onClick={onClose}
        aria-label={t('appStatus.form.closeImage')}
      >
        <i className="pi pi-times" aria-hidden="true" />
      </button>
      <div className={styles['image-viewer-content']}>
        <img src={url} alt={alt} />
      </div>
    </div>,
    document.body,
  );
};

export default ImageViewerModal;
